import { CardType } from '../../../components/common/card/Card';
import { DataTransformer } from '../cardDataTransformers';

const searchResultsFieldsTransformer: DataTransformer<CardType.SearchResult> = (
  data,
) => data;

export default searchResultsFieldsTransformer;
